import ConfirmationPage from '../../shared/booking/ConfirmationPage';
import FlightSummary from './FlightSummary';
import FlightBookingServices from './FlightBookingServices';

export default function FlightConfirmation() {
  return (
    <ConfirmationPage
      module="flights"
      Summary={FlightSummary}
      refLabel="Airline PNR"
      Extra={FlightBookingServices}
      nextSteps={[
        'Your e-ticket has been emailed — keep it handy on your phone.',
        'Complete web check-in 48 hours before departure to choose seats.',
        'Reach the airport at least 2 hours before departure.',
        'Manage, reschedule or cancel anytime from My Trips.',
      ]}
    />
  );
}
